import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../../layout/Header';
import Footer from '../../../layout/Footer';
import NotFoundSvg from './NotFoundSvg';
import { Button } from '../../../components/ui/button';

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className='h-screen flex flex-col'>
      <Header />
      <div className='relative flex flex-col lg:flex-row flex-grow mb-12'>
        <div className='flex items-center justify-center h-1/3 md:h-1/2 lg:h-full w-full lg:w-1/2 notfound-svg-container'>
          <NotFoundSvg/>
        </div>
        <div className='flex flex-col items-center justify-center px-14 w-full lg:h-full lg:w-1/2'>
          <h1 className='text-primary text-2xl lg:text-4xl font-bold mb-4'>Page Not Found</h1>
          <div className='mb-4 px-10 text-center'>
            <p>So sorry, the page cannot be found or you don't have access to it.</p>
            <p>Please go back to your dashboard.</p>
          </div>
          <Button variant="outline" size="lg" className="mb-4" onClick={() => navigate('/')}>Take Me Home</Button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default NotFoundPage;
